<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <CauseOfMaintanceList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CauseOfMaintanceList from "@/components/settings/test-registers/causeOfMaintance/CauseOfMaintanceList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "CauseOfMaintance",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    CauseOfMaintanceList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addcauseofmaintance" });
    },
  },
};
</script>
